import { render, staticRenderFns } from "./CardManuales.vue?vue&type=template&id=4f98bc5a&scoped=true&"
import script from "./CardManuales.vue?vue&type=script&lang=js&"
export * from "./CardManuales.vue?vue&type=script&lang=js&"
import style0 from "./CardManuales.vue?vue&type=style&index=0&id=4f98bc5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f98bc5a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})
